export default __webpack_public_path__ + "static/media/aroma_pizza_logo.ed042cfc.jpeg";